import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop - Component that scrolls to top on route change
 * Automatically scrolls to the top of the page whenever the route changes
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top when pathname changes
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
